import { useTracking } from 'opensolar-common'
import { useEffect } from 'react'
import { usePublicFeatureConfig } from './usePublicFeatureConfig'

/**
 * This logic loads the default event config from the feature config into the tracking context.
 * It has to be done from inside the tracking context as it relies on redux.
 */
export const useLoadDefaultEventConfig = () => {
  const { setDefaultEventConfig } = useTracking()
  const featureConfig = usePublicFeatureConfig('event_config')
  useEffect(() => {
    if (featureConfig) {
      setDefaultEventConfig(featureConfig.backends)
    }
  }, [featureConfig])
}
